import React, { Component } from 'react';

import Helmet from './Helmet';

export default class TermsHelmet extends Component {
  render() {
    return <Helmet title="Terms of Service | Canny" />;
  }
}
